var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7442 1.79826V0H19.2794V1.79826C19.5125 1.73263 19.758 1.69675 20.0118 1.69675C20.2656 1.69675 20.5111 1.73258 20.7442 1.79826Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3053 4.40322C17.3053 4.14943 17.3412 3.90393 17.4068 3.67084H15.6086V5.13561H17.4068C17.3412 4.90252 17.3053 4.65707 17.3053 4.40322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0118 5.64497C20.6975 5.64497 21.2535 5.08903 21.2535 4.40324C21.2535 3.71744 20.6975 3.1615 20.0118 3.1615C19.326 3.1615 18.77 3.71744 18.77 4.40324C18.77 5.08903 19.326 5.64497 20.0118 5.64497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3712 3.07956L23.3175 2.13322L22.2818 1.09747L21.3354 2.04382C21.7682 2.2876 22.1274 2.64677 22.3712 3.07956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6881 2.04382L17.7418 1.09747L16.7061 2.13322L17.6524 3.07956C17.8962 2.64677 18.2553 2.2876 18.6881 2.04382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3175 6.67321L22.3712 5.72687C22.1274 6.15966 21.7682 6.51882 21.3354 6.76261L22.2818 7.70895L23.3175 6.67321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.415 5.13561V3.67084H22.6168C22.6824 3.90393 22.7183 4.14943 22.7183 4.40322C22.7183 4.65702 22.6824 4.90252 22.6168 5.13561H24.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2794 7.00824V8.80645H20.7442V7.00824C20.5111 7.07386 20.2656 7.10975 20.0118 7.10975C19.758 7.10975 19.5126 7.07386 19.2794 7.00824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6524 5.72687L16.7061 6.67321L17.7418 7.70895L18.6881 6.76261C18.2553 6.51882 17.8962 6.15966 17.6524 5.72687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000610352 25.0001H7.54078C5.2551 23.6013 2.80731 23.1929 0.000610352 23.137V25.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4773 21.7234H24.9994V19.9116H16.2526C17.0183 20.463 17.759 21.0667 18.4773 21.7234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000610352 16.6404V18.512C3.30407 18.5739 6.11336 19.0597 8.56876 19.9921C11.3275 21.0398 13.7436 22.6796 15.9459 25H19.6238C14.6981 19.3105 8.71397 16.7734 0.000610352 16.6404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5284 24.9999H24.9994V23.1881H19.9592C20.4946 23.7586 21.0174 24.3621 21.5284 24.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000610352 21.6715C3.3297 21.733 6.80762 22.2748 10.0269 25H13.8645C10.2215 21.6264 5.95238 20.0912 0.000610352 19.9767V21.6715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94442 10.1687C8.28777 10.4172 8.62964 10.6174 8.88691 10.7561V15.1701H10.3517V10.7561C10.6089 10.6174 10.9508 10.4172 11.2942 10.1687C12.3216 9.42495 12.8425 8.63275 12.8425 7.81409V3.29335C12.8425 2.47469 12.3216 1.68249 11.2942 0.938774C10.618 0.449344 9.94682 0.146624 9.91855 0.134027L9.6193 0L9.32004 0.134027C9.29177 0.146673 8.62056 0.449344 7.94442 0.938774C6.91698 1.68249 6.39606 2.47469 6.39606 3.29335V7.81409C6.39601 8.63275 6.91698 9.42495 7.94442 10.1687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75073 16.6349C10.508 16.8798 11.24 17.1554 11.9478 17.463C12.6308 17.7598 13.2954 18.0877 13.9433 18.4468H24.9994V16.6349H9.75073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61013 13.0877V15.1701H4.07491V13.0877C4.96642 12.7824 5.60936 11.9366 5.60936 10.9429C5.60936 10.0132 4.38705 7.17422 4.01246 6.32626L3.34257 4.80988L2.67263 6.32626C2.29804 7.17422 1.07568 10.0132 1.07568 10.9429C1.07573 11.9366 1.71862 12.7824 2.61013 13.0877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 15.1701V13.4747C22.8379 13.6628 20.8994 14.2224 19.137 15.1701H24.9994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0333 15.1701H16.4264C18.9155 13.3068 21.7285 12.2673 24.9994 12.0049V10.5566C20.007 10.6837 16.2319 12.1314 13.0333 15.1701Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.54414c1361934d86522f29e945682bda.svg";
export { ForwardRef as ReactComponent };